export const timer = (timer: number = 500) =>
  new Promise((resolve) => setTimeout(resolve, timer));

export const randomRange = (min: number, max: number) =>
  Math.floor(Math.random() * (max - min)) + min;

export const generateSimpleUUID = () => {
  return "xxxxxxxx-xxxx".replace(/[x]/g, () => {
    const random = (Math.random() * 16) | 0;
    return random.toString(16);
  });
};

export const isJSON = (json): boolean => {
  try {
    const resJSON = JSON.parse(json);
    return resJSON && true;
  } catch (error) {
    return false;
  }
};